<template>
    <span class="artist" :class="{ invert: props.invert }">
        <template v-for="(item, id) in primaryArtists" :key="id">
            <Button v-if="item.id && !props.readonly"
                class="size-s tertiary gray link"
                :class="{ invert: props.invert }"
                @click.stop="openArtist(item)"
            >
                <span class="name">{{ `${item.name}${ id < primaryArtists.length - 1 ? ',' : ''}` }}</span>
            </Button>
            <span v-else>{{ `${item.name}${ id < primaryArtists.length - 1 ? ',' : ''}` }}</span>
        </template>

        <template v-if="featArtists?.length">
            <span>feat.</span>

            <template v-for="(item, id) in featArtists" :key="id">
                <Button v-if="item.id && !props.readonly"
                    class="size-s tertiary gray link"
                    :class="{ invert: props.invert }"
                    @click.stop="openArtist(item)"
                >
                    <span class="name">{{ `${item.name}${ id < featArtists.length - 1 ? ',' : ''}` }}</span>
                </Button>
                <span v-else>{{ `${item.name}${ id < featArtists.length - 1 ? ',' : ''}` }}</span>
            </template>
        </template>
    </span>
</template>

<script setup>
    import { computed } from 'vue';
    import Button from '🔗/components/ui/Button.vue';
    import stores from '@/stores';

    const nav = stores.nav();

    const props = defineProps({
        items: { type: Array, default: () => ([]) },
        invert: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false }
    });

    const primaryArtists = computed(() => {
        return props.items?.filter(item =>
            item.role === 'PRIMARY' && (item.artist?.name || item.unregisteredArtistName)).map(item => ({
                name: item.artist?.name || item.unregisteredArtistName,
                id: item.state === 'CONFIRMED' ? item.artist?.id : null,
                code: item.state === 'CONFIRMED' ? item.artist?.code : null
            })) || []
    });

    const featArtists = computed(() => {
        return props.items?.filter(item =>
            item.role === 'FEATURED' && (item.artist?.name || item.unregisteredArtistName)).map(item => ({
                name: item.artist?.name || item.unregisteredArtistName,
                id: item.state === 'CONFIRMED' ? item.artist?.id : null,
                code: item.state === 'CONFIRMED' ? item.artist?.code : null
            })) || []
    });

    const openArtist = (item) => {
        if (!item?.code) {
            return;
        }

        nav.open('artist', { code: item?.code });
    }
</script>

<style lang="scss" scoped>
    .artist {
        font: var(--font-caption);
        color: var(--dark-80);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        flex: 1;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        mask-image: linear-gradient(to right, black 90%, transparent 100%);
        width: 100%;

        span {
            opacity: .8;
        }

        .name {
            font: var(--font-caption);
            color: var(--dark-80);
        }

        &.invert {
            color: var(--light-500);
            .name {
                color: var(--light-80);
            }
        }

        &.size-l {
            font: var(--font-body-2);
            .name {
                font: var(--font-body-2);
            }
        }
    }

    .direction-rtl .artist {
        mask-image: linear-gradient(to left, black 90%, transparent 100%);
    }
</style>